// Error handling shared by the three "save route" flows (editRouteClients,
// createRouteBeartrack, ProgramarRecoleccionModal).
//
// addRouteApi/updateRoute never reject: on failure they RESOLVE
// `{ error: <backend body> | <axios transport message> }`. So the value these
// helpers receive is that `error`, not an axios error — and the backend codes
// (no `message` at all in the 409/400 below) have to be turned into text the
// user can act on.

import { apiBodyMessage, apiErrorCode } from './apiErrorMessage';

// microservice-routes codes.
export const ROUTE_STOPS_REMOVAL_NOT_CONFIRMED = 'route_stops_removal_not_confirmed';
export const ROUTE_EMPTY_CLIENTS = 'route_empty_clients';

/**
 * true when the body is the 409 asking to confirm the stops that would be
 * removed. False for null, strings and any other code.
 * @param {unknown} error - the `error` resolved by addRouteApi/updateRoute
 * @returns {boolean}
 */
export function isStopsRemovalConflict(error) {
  return apiErrorCode(error) === ROUTE_STOPS_REMOVAL_NOT_CONFIRMED;
}

/**
 * UI text for the `error` returned by addRouteApi/updateRoute (a body or a
 * transport string). Never returns raw axios noise.
 * @param {unknown} error
 * @param {(key: string, options?: object) => string} t
 * @returns {string}
 */
export function routeErrorText(error, t) {
  const code = apiErrorCode(error);
  if (code === ROUTE_EMPTY_CLIENTS) return t('La ruta debe tener al menos una parada.');
  if (code === ROUTE_STOPS_REMOVAL_NOT_CONFIRMED) {
    return t('La ruta cambió: hay paradas que se quitarían. Vuelve a abrirla y confirma.');
  }
  return apiBodyMessage(error) ?? t('Error al guardar la ruta');
}
